import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useLocale } from "../../i18n";
import SEO, { buildBreadcrumb } from "../../components/SEO";

export default function ToolShell({ title, subtitle, icon: Icon, children, testid, seoTitle, seoDescription, seoPath }) {
  const { locale } = useLocale();

  const jsonLd = seoPath ? [
    {
      "@context": "https://schema.org",
      "@type": "WebApplication",
      name: seoTitle || title,
      description: seoDescription || subtitle,
      url: `https://wowromania.com${seoPath}`,
      applicationCategory: "TravelApplication",
      operatingSystem: "Web",
      inLanguage: locale,
      isAccessibleForFree: true,
    },
    buildBreadcrumb([
      { name: locale === "ro" ? "Acasă" : "Home", path: "/" },
      { name: "Tools", path: "/tools" },
      { name: title, path: seoPath },
    ]),
  ] : [];

  return (
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16 lg:py-20" data-testid={testid}>
      {seoPath && (
        <SEO title={seoTitle || title} description={seoDescription || subtitle} path={seoPath} jsonLd={jsonLd} />
      )}
      <Link to="/tools" className="inline-flex items-center gap-2 font-mono-wr text-[11px] uppercase tracking-widest mb-8 text-[var(--wr-ink-2)] hover:text-[var(--wr-red)] transition-colors" data-testid="back-to-tools">
        <ArrowLeft size={14} /> {locale === "ro" ? "Toate Tools" : "All tools"}
      </Link>
      <div className="grid lg:grid-cols-12 gap-8 items-end mb-12">
        <div className="lg:col-span-8">
          <div className="flex items-center gap-3 mb-4">
            {Icon && <Icon size={26} className="text-[var(--wr-red)]" />}
            <p className="font-mono-wr text-[11px] uppercase tracking-[0.3em] text-[var(--wr-red)]">
              / TOOL
            </p>
          </div>
          <h1 className="font-editorial text-5xl sm:text-6xl lg:text-7xl leading-[0.98] tracking-tight text-[var(--wr-ink)]">
            {title}
          </h1>
        </div>
        <p className="lg:col-span-4 text-[15px] text-[var(--wr-ink-2)] leading-relaxed">
          {subtitle}
        </p>
      </div>
      {children}
    </div>
  );
}
